<template>
  <div class="ccontainer" v-if="!videoCallRoom.is_unlimited && videoCallRoom.is_sender">
    <div class="prejoin-preview-dropdown-container">
      <div
        aria-label="Comprar 1 minuto extra"
        class="css-1hbmoh1-actionButton secondary"
        role="button"
        tabindex="0"
        @click="showModal = true"
      >
        {{ $t("videocall.button.buy_extra_minute") }}
      </div>
    </div>
    <ExtendCallModal 
      v-if="showModal" 
      :videoCallRoom="videoCallRoom" 
      @cancel="showModal = false"
    />
  </div>
</template>

<script>
import ExtendCallModal from "../Modal/ExtendCall";

export default {
  components: {
    ExtendCallModal,
  },
  props: {
    videoCallRoom: {
      required: true,
      default: () => {
        return {};
      },
    }
  },
  data() {
    return {
      showModal: false,
    };
  },
};
</script>

<style scoped lang="scss" >
@import "../jisti.scss";
</style>
